// _services/infoService.js
import api from '../../../api/axios';
import { Quill } from 'react-quill-new';
import BlotFormatter from 'quill-blot-formatter';

Quill.register('modules/blotFormatter', BlotFormatter);

export const infoService = {
  // ==========================================
  // 📥 OBTENER INFO (Devuelve SOLO el payload limpio)
  // ==========================================
  getInfo: async (slug) => {
    const response = await api.get(`/admin/template/${slug}/info`);
    
    // El backend devuelve: { success: true, data: { type: 'html', content: '...' } }
    // Extraemos directamente el objeto 'data' interno para que el hook no tenga que adivinar
    return response.data?.data || { type: 'html', content: '' };
  },

  // ==========================================
  // 💾 GUARDAR INFO HTML
  // ==========================================
  saveHtml: async (slug, htmlContent) => {
    const token = localStorage.getItem("token");
    const response = await api.put(`/admin/template/${slug}/info`, {
      info_content: htmlContent, // El backend acepta esto
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // ==========================================
  // 📄 SUBIR PDF
  // ==========================================
  uploadPdf: async (slug, pdfFile) => {
    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append('info_type', 'pdf');
    formData.append('pdfFile', pdfFile);

    const response = await api.put(`/admin/template/${slug}/info`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      }
    });
    return response.data;
  },

  // ==========================================
  // 🗑️ ELIMINAR ARCHIVO
  // ==========================================
  deleteFile: async (slug, filename) => {
    const token = localStorage.getItem("token");
    const response = await api.delete(`/admin/template/${slug}/info/file`, {
      headers: { Authorization: `Bearer ${token}` },
      data: { filename }
    });
    return response.data;
  },

  // ==========================================
  // 🎨 CONFIGURACIÓN DE QUILL
  // ==========================================
  getQuillModules: () => ({
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['link', 'image'],
      ['clean']
    ],
    blotFormatter: {
      overlay: { style: { border: '2px solid #007bff' } }
    }
  }),

  getQuillFormats: () => [
    'header', 'bold', 'italic', 'underline', 'strike',
    'color', 'background', 'align', 'list',
    'link', 'image' 

  ]
};